import React, { Component } from 'react'
import { base } from '../../base';
import CupRowComponent from "../small_components/CupRowComponent";
import CupShuffler from '../small_components/CupShuffler';
import {generateRandomNumber, swapElements, shuffle, isObjectEmpty} from '../utils/HelpfulFunction';
import Loading from "../utils/Loading";
import Confetti from 'react-confetti';
import clone from 'clone';
import swal from 'sweetalert2';

// game timers.
const SHUFFLE_TIMER = 350;
const GAME_START_DELAY = 1300;

// We will use this instance to generate our game moves.
let cupShuffler = new CupShuffler();
let shuffleTimer;
let updateBallPositionTimer;
let lastSetTimeOut;
let displayPositionTimer;
let endGameTimer;
let gameTimer;

class BigScreenVideo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tenantVariables: {},
            cupPositions: cupShuffler.getInitialCupPositions(),
            gameInProgress: false,
            ballPosition: 1,
            loading: true,
            width: 0,
            height: 0,
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.tenantVariablesRef = base.syncState('tenantVariables', {
            context: this,
            state: 'tenantVariables',
            then(data){
                this.setState({
                    loading: false
                })
                cupShuffler.setNumberOfMoves(this.state.tenantVariables.numberOfMoves)
            }
        })
        this.startShuffleRef = base.listenTo('startShuffle', {
            context: this,
            then(stateOfShuffle){
                if(stateOfShuffle === true){
                    let gameStartDelay = this.state.tenantVariables.secondsToBegin;
                    if(gameStartDelay){
                        gameStartDelay = gameStartDelay * 1000
                    } else {
                        gameStartDelay = GAME_START_DELAY
                    }
                    this.clearAllTimers();
                    lastSetTimeOut = setTimeout(() => {
                        cupShuffler.startNewGame((moves) => {
                            this.startGame(moves);
                        });
                    }, gameStartDelay);
                } else if(stateOfShuffle === false) {
                    this.clearAllTimers();
                    this.setState({
                        cupPositions: cupShuffler.getInitialCupPositions(),
                        gameInProgress: false,
                        ballPosition: 1,
                        startConfetti: false
                    })
                }
            }
        })
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    clearAllTimers(){
        if(lastSetTimeOut){
            clearTimeout(lastSetTimeOut)
        }
        if(shuffleTimer){
            clearTimeout(shuffleTimer)
        }
        if(updateBallPositionTimer){
            clearTimeout(updateBallPositionTimer)
        }
        if(displayPositionTimer){
            clearTimeout(displayPositionTimer)
        }
        if(endGameTimer){
            clearTimeout(endGameTimer)
        }
        if(gameTimer){
            clearInterval(gameTimer)
        }
    }

    componentWillUnmount() {
      // Make sure to revoke the data uris to avoid memory leaks
      base.removeBinding(this.tenantVariablesRef);
      base.removeBinding(this.startShuffleRef);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    startGame (moves) {
        this.setState({
            gameInProgress: true,
        });
        const tenantVariables = this.state.tenantVariables || {};
        let toMakeWinner = tenantVariables.toMakeWinner;

        if(toMakeWinner){
            toMakeWinner = parseInt(toMakeWinner);
            let finalMove = moves[moves.length - 1];
            if(finalMove[0] !== toMakeWinner){
                let locationOfWinner = finalMove.indexOf(toMakeWinner);
                let previousValueOfWinnerSection = clone(finalMove[0]);
                finalMove[0] = toMakeWinner;
                finalMove[locationOfWinner] = previousValueOfWinnerSection;
                moves[moves.length - 1] = finalMove;
            }
        }

        shuffleTimer = setTimeout(() => {
            this.shuffleCups(moves);
            this.setState({
                ballPosition: null,
            });
        }, GAME_START_DELAY);
    }

    handleImageLoaded(){
        this.setState({
            loading: false
        })
    }

    handleImageErrored(){
        this.setState({
            loading: false
        })
    }

    shuffleCups (moves) {
        const tenantVariables = this.state.tenantVariables || {};
        let shuffleCount = 0;
        let numberOfSecondsFromAdmin = tenantVariables.numberOfSeconds;
        let secondsPerMove;
        if(numberOfSecondsFromAdmin && parseInt(numberOfSecondsFromAdmin) > 0 && moves && moves.length > 0){
           secondsPerMove = parseInt(parseInt(numberOfSecondsFromAdmin)/moves.length * 1000)
        }
        let shuffleTimer = secondsPerMove || SHUFFLE_TIMER;
        gameTimer = setInterval(() => {

            this.setState({
                cupPositions: moves[shuffleCount]
            });

            // Clear out the interval when we have gone through
            // all the moves. We also set the ball position to the position
            // of cup 0 from the last move.
            shuffleCount++;
            if (shuffleCount === moves.length) {
                this.updateBallPosition(moves[shuffleCount - 1][0])
                clearInterval(gameTimer);
                this.onEndGame(moves[shuffleCount - 1][0]);
            }

        }, shuffleTimer);
    }

    /**
     * Update the ballposition after a delay. This delay is to allow the
     * animation to compelete.
     * @param  {Number} position - Position of where to place the ball.
     */
    updateBallPosition (position) {
        updateBallPositionTimer = setTimeout(() => {
            this.setState({
                ballPosition: position
            });
        }, 500);
    }

    /**
     * Will shuffle two random cups. Does by shuffling an array that
     * represents the default cup positions and taking the first two items. This
     * will essentially give us two random cup positions that we can swap.
     */
    swapRandomCups () {
        let shuffledIndexes = shuffle(clone(CUP_INDEXES));
        swapElements(this.cupPositions, shuffledIndexes[0], shuffledIndexes[1]);
    }

    /**
     * End game handler that sets the end game state based on a win or
     * loss.
     * @param  {Boolean} isWinner    - Boolean if user won.
     * @param  {Number}  endPosition - Number representing the ending position
     *                                 of the ball.
     */
    onEndGame (endPosition) {
        const tenantVariables = this.state.tenantVariables || {};
        let secondsToReveal = tenantVariables.secondsToReveal;
        if(secondsToReveal){
            secondsToReveal = secondsToReveal * 1000;
        } else {
            secondsToReveal = 10000;
        }
        displayPositionTimer = setTimeout(()=> {
            this.setState({
                displayPosition: true
            })
        }, 1000)
        endGameTimer = setTimeout(() => {
            this.setState({
                gameInProgress: false,
                startConfetti: true,
                displayPosition: false
            }, () => {
                if(tenantVariables.winningHeader || tenantVariables.winningBody){
                    swal({
                        title: tenantVariables.winningHeader || "",
                        text: tenantVariables.winningBody || "",
                        showConfirmButton: false
                    });
                }
            });
        }, secondsToReveal);
    }

    render() {
        const tenantVariables = this.state.tenantVariables || {};
        const topAdImage = tenantVariables.topAdImage;
        const backgroundImage = tenantVariables.backgroundImage;
        const shellImage = tenantVariables.shellImage;
        const hiddenItemImage = tenantVariables.hiddenItemImage;
        const displayPosition = this.state.displayPosition || false;
        const turnOffConfetti = tenantVariables.turnOffConfetti || false;
        if (this.state.loading === true) {
            return (
                <Loading loading={this.state.loading}/>
            )
        }

        return (
            <div className="jumbotron d-flex align-items-center min-vh-100" style={{backgroundImage: "url(" + backgroundImage + ")"}}>
                {this.state.startConfetti && !turnOffConfetti &&
                    <Confetti width={this.state.width} height={this.state.height} style={{zIndex: 101 }}/>
                }
                <div style={{width:"100%", textAlign: "center",position: "absolute",top: 0}}>
                    <img width="100%" src={topAdImage} onLoad={this.handleImageLoaded.bind(this)} onError={this.handleImageErrored.bind(this)} alt="" style={{width: "auto"}}/>
                </div>
                <div className="container text-center">
                    <CupRowComponent displayPosition={displayPosition} colorOfPosition={tenantVariables.colorSelectionNumber} textShadowColor={tenantVariables.textShadowColor} toggleTextShadow={tenantVariables.toggleTextShadow} tweenDuration={1000} numberOfPieces={10000} shellImage={shellImage} hiddenItemImage={hiddenItemImage} {...this.state} />
                </div>
            </div>
        )
    }
}

export default BigScreenVideo
